import { render, staticRenderFns } from "./wigs-details-print-page-properties-list.vue?vue&type=template&id=2bc75954"
import script from "./wigs-details-print-page-properties-list.vue?vue&type=script&lang=js"
export * from "./wigs-details-print-page-properties-list.vue?vue&type=script&lang=js"
import style0 from "./wigs-details-print-page-properties-list.vue?vue&type=style&index=0&id=2bc75954&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports